import React, { useEffect } from 'react';
import styled from 'styled-components';
import { FlexView, Row, Separator, Text } from '@cuemath/comps';

import StatusBadge from './status-badge';

const Panel = styled(FlexView)`
  && {
    padding-top: 20px;
    border-top: 1px solid #eee;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

const PanelTitle = styled(Text)`
  && {
    font-size: 13px;
    font-weight: 600;
    color: #555;
  }
`;

const ItemRow = styled(Row)`
  && {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 8px;
    border-radius: 4px;
    cursor: ${({ $selected, $clickable }) =>
      $clickable && !$selected ? 'pointer' : 'default'};
    background: ${({ $selected }) => ($selected ? '#E8F0FE' : 'transparent')};

    &:hover {
      background: ${({ $selected, $clickable }) =>
        $clickable && !$selected ? '#f5f5f5' : $selected ? '#E8F0FE' : 'transparent'};
    }
  }
`;

const VersionNumber = styled(Text)`
  && {
    font-size: 12px;
    font-weight: 600;
    color: #2b2b2b;
    min-width: 40px;
  }
`;

const Timestamp = styled(Text)`
  && {
    font-size: 11px;
    color: #888;
    margin-left: auto;
  }
`;

const EmptyNote = styled(Text)`
  && {
    font-size: 12px;
    color: #999;
  }
`;

const formatTime = epoch => {
  if (!epoch) return '';
  const date = new Date(epoch * 1000);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleString();
};

function VersionsPanel({ versions, selectedId, onSelect, loadKey, onLoad }) {
  useEffect(() => {
    if (loadKey && onLoad) {
      onLoad(loadKey);
    }
  }, [loadKey, onLoad]);

  const rows = Array.isArray(versions) ? versions : [];
  const sorted = [...rows].sort((a, b) => (b.created_on || 0) - (a.created_on || 0));

  return (
    <>
      <Separator height={20} transparent />
      <Panel>
        <PanelTitle>Versions</PanelTitle>
        {sorted.length === 0 && <EmptyNote>No other versions</EmptyNote>}
        {sorted.map(v => {
          const selected = v.id === selectedId;
          const clickable = Boolean(onSelect) && !selected;
          return (
            <ItemRow
              key={v.id}
              $selected={selected}
              $clickable={clickable}
              onClick={clickable ? () => onSelect(v) : undefined}
            >
              <VersionNumber>v{v.version}</VersionNumber>
              <StatusBadge status={v.status} />
              <Timestamp>{formatTime(v.updated_on || v.created_on)}</Timestamp>
            </ItemRow>
          );
        })}
      </Panel>
    </>
  );
}

export default VersionsPanel;
